module.exports = __webpack_public_path__ + "img/npublicaciones.55fa18b3.svg";